<template>
  <div class="container">
    <div class="btn-wrapper">
      <el-button class="add-new-btn" @click="handleChange(1)">
        <i class="iconfont iconProperty1tianjia"></i> Add
      </el-button>
    </div>
    <div>
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        v-loading="loading"
        :default-sort="{order:'ascending'}"
        @sort-change="sortChange"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="ID" prop="id" min-width="140"></el-table-column>
        <el-table-column
          label="Description"
          prop="description"
          show-overflow-tooltip
          sortable="custom"
          min-width="280"
        >
          <template v-slot="{row}">
            <div class="table-label">{{ row.description }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Rule" min-width="150">
          <template v-slot="{row}">
            <div v-for="item in row.rules" :key="item.id">{{ item.cnName }};</div>
          </template>
        </el-table-column>
        <el-table-column label="Mode" min-width="150">
          <template v-slot="{row}">
            <div v-if="row.modeFlag === 1">Any</div>
            <div v-else-if="row.modeFlag === 2">And</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="Label" prop="labelName" min-width="150"></el-table-column>
        <el-table-column label="Active" prop="activeFlag" min-width="80" align="center">
          <template v-slot="{row}">
            <div class="check-list">
              <el-checkbox
                v-model="row.activeFlag"
                :true-label="1"
                :false-label="0"
                @change="checkBoxChange(row)"
              ></el-checkbox>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Last Modify" prop="updateTime" sortable="custom" min-width="150">
          <template v-slot="{row}">
            <div v-if="row.updateTime">{{ formatUtc(row.updateTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Remark" prop="remark" :show-overflow-tooltip="true" min-width="234"></el-table-column>

        <el-table-column label="Operation" min-width="280" fixed="right">
          <template v-slot="{row}">
            <div>
              <el-button class="table-inner-btn" @click="handleChange(2,row)">Modify</el-button>
              <el-button class="table-inner-btn" @click="handleChange(4,row)">Copy</el-button>
              <el-button class="table-inner-btn" @click="handleChange(3,row)">Delete</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <dia ref="dialogDom" class="label-dialog">
      <!-- 添加1修改2 -->
      <div v-if="num == 2 || num == 1 || num == 4">
        <el-form :model="form" label-width="156px">
          <el-form-item label="Description">
            <el-input
              style="width:72.5%;"
              v-model="form.description"
              maxlength="200"
              autocomplete="off"
              placeholder="Input Description"
            ></el-input>
          </el-form-item>
          <el-form-item label="If">
            <el-select
              style="width:72.5%;"
              v-model="form.modeFlag"
              filterable
              placeholder="Select If"
            >
              <el-option
                v-for="item in ifList"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <div class="rules-box">
            <ul class="rules">
              <li
                v-for="item in ruleList"
                :key="item.id"
                :class="{'active':form.ruleIds.includes(item.id)}"
                @click="activeLi(item.id)"
              >{{item.cnName}}</li>
            </ul>
          </div>
          <el-form-item class="Tag" label="Tag The Follwoing Label To User">
            <el-select
              style="width:60%;"
              v-model="form.labelId"
              filterable
              clearable
              placeholder="Select Level Id"
            >
              <el-option
                v-for="item in labelList"
                :key="item.id"
                :label="item.labelName"
                :value="Number(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Remark">
            <el-input style="width:72.5%;" v-model="form.remark" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleViewModify()" v-if="num == 2">Confirm</el-button>
          <el-button class="search-btn" @click="handleViewAdd()" v-if="num == 1 || num == 4">Confirm</el-button>
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
      <!-- 删除3 -->
      <div class="dialog-footer table-search-part" v-if="num == 3">
        <el-button class="search-btn" @click="Delete()">Confirm</el-button>
        <el-button class="clear-btn" @click="Close()">Cancel</el-button>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import {
  getLabelRule,
  addLabelRule,
  updateLabelRule,
  deleteLabelRule,
  findAllLabel,
  getRuleList
} from "@/api/lable";
export default {
  name: "LableList",
  data() {
    return {
      form: {
        description: "",
        modeFlag: 2,
        remark: "",
        labelId: "",
        ruleIds: []
      },
      id: "",
      num: "",
      list: [],
      ruleList: [],
      labelList: [],
      queryData: {
        current: 1,
        size: 50
      },
      ifList: [
        {
          id: 2,
          name: "And"
        },
        {
          id: 1,
          name: "Any"
        }
      ],
      total: 0,
      loading: false,
      ids: "",
      tableHeight: window.innerHeight,
      title: "Delete the Label?"
    };
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await getLabelRule(this.queryData);
        const data = res.data || {};
        this.list = data.records || [];
        this.total = Number(data.total);
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getRuleList() {
      try {
        const res = await getRuleList({});
        const data = res.data || {};
        this.ruleList = data;
      } catch (error) {
        this.ruleList = [];
      }
    },
    async findAllLabel() {
      try {
        const res = await findAllLabel({});
        const data = res.data || {};
        this.labelList = data;
      } catch (error) {
        this.labelList = [];
      }
    },
    sortChange(e) {
      if (e.order) {
        const orderData = [
          {
            column: e.column.property,
            asc: e.order === "ascending" ? true : false
          }
        ];
        this.queryData.orders = orderData;
      } else {
        this.queryData.orders = [];
      }
      this.getList();
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    activeLi(val) {
      if (this.form.ruleIds.includes(val)) {
        var index = this.form.ruleIds.indexOf(val);
        if (index > -1) {
          this.form.ruleIds.splice(index, 1);
        }
      } else {
        this.form.ruleIds.push(val);
      }
    },
    async checkBoxChange(val) {
      let param = {
        id: val.id,
        activeFlag: val.activeFlag
      };
      const res = await updateLabelRule(param);
      if (res.success) {
        this.$message({ message: "Active update success", type: "success" });
        this.getList();
      }
    },
    // 添加
    async handleViewAdd(data) {
      if (!this.form.description) {
        this.$message({
          message: "The description can not be empty",
          type: "warning"
        });
        return false;
      }
      if (this.isEmpty(this.form.ruleIds)) {
        this.$message({
          message: "The ruleIds can not be empty",
          type: "warning"
        });
        return false;
      }
      if (!this.form.labelId) {
        this.$message({
          message: "The labelId can not be empty",
          type: "warning"
        });
        return false;
      }

      const res = await addLabelRule(this.form);
      if (res.success) {
        this.$message({ message: "add success", type: "success" });
        this.getList();
      }
      this.Close();
    },
    isEmpty(value) {
      if (value === null) {
        return true;
      }
      if (Array.isArray(value)) {
        return !value.length;
      }
      if (value instanceof Object) {
        return JSON.stringify(value) === "{}";
      }
      return true;
    },
    handleChange(num, data) {
      this.num = num;
      if (num == 1) {
        // 添加
        this.title = "New Label";
        this.form = {
          description: "",
          modeFlag: 2,
          remark: "",
          labelId: "",
          ruleIds: []
        };
      } else if (num == 2) {
        // 修改
        let ruleIds = [];
        if (!this.isEmpty(data.rules)) {
          data.rules.map(item => {
            ruleIds.push(item.id);
          });
        }
        this.title = "Modify Label";
        this.form.description = data.description;
        this.form.modeFlag = data.modeFlag;
        this.form.labelId = data.labelId;
        this.form.id = data.id;
        this.form.remark = data.remark;
        this.form.ruleIds = ruleIds;
      } else if (num == 4) {
        // 修改
        this.title = "Copy Label";
        let ruleIds = [];
        if (!this.isEmpty(data.rules)) {
          data.rules.map(item => {
            ruleIds.push(item.id);
          });
        }
        this.form.description = data.description + "-copy";
        this.form.id = "";
        this.form.modeFlag = data.modeFlag;
        this.form.labelId = data.labelId;
        this.form.remark = data.remark;
        this.form.ruleIds = ruleIds;
      } else {
        // 删除
        this.title = "Delete Label?";
        this.ids = [data.id];
      }
      this.$refs["dialogDom"].isShowDia(this.title, true, "500px");
    },
    // 修改
    async handleViewModify(data) {
      if (!this.form.description) {
        this.$message({
          message: "The description can not be empty",
          type: "warning"
        });
        return false;
      }
      if (this.isEmpty(this.form.ruleIds)) {
        this.$message({
          message: "The ruleIds can not be empty",
          type: "warning"
        });
        return false;
      }
      if (!this.form.labelId) {
        this.$message({
          message: "The labelId can not be empty",
          type: "warning"
        });
        return false;
      }
      const res = await updateLabelRule(this.form);
      if (res.success) {
        this.$message({ message: "update success", type: "success" });
        this.getList();
      }
      this.Close();
    },
    // 删除
    async Delete() {
      const res = await deleteLabelRule({ ids: this.ids });
      if (res.code == 0) {
        this.$message({ message: "delete success", type: "success" });
        this.getList();
        this.Close();
      }
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "500px");
    }
  },
  mounted() {
    this.getRuleList();
    this.findAllLabel();
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  },
  components: {
    dia,
    Empty
  }
};
</script>

<style lang="scss" scoped>
.btn-wrapper {
  margin: 20px 0;
}
.table-label {
  color: #666;
  font-weight: bold;
}
/deep/.el-form-item__label {
  width: 80px !important;
}
/deep/.el-form-item__content {
  margin-left: 80px !important;
}
/deep/.table-simple-checkbox {
  .el-checkbox__label {
    display: none;
  }
}
/deep/.Tag {
  .el-form-item__label {
    width: 200px !important;
  }
  .el-form-item__content {
    margin-left: 200px !important;
  }
}
.rules-box {
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  padding: 8px 8px;
  margin-bottom: 10px;
  .rules {
    list-style: none;
    overflow: hidden;
    cursor: pointer;
    padding: 8px 0 0 8px;
    display: flex;
    background: #f3f3f3;
    border-radius: 10px;
    flex-wrap: wrap;
    li {
      margin-bottom: 8px;
      margin-right: 8px;
      padding: 4px 8px;
      border-radius: 4px;
      border: 1px solid #dedfe4;
      color: #666;
      font-size: 14px;
      background: #fff;
    }
    .active {
      border: 1px solid #00a791;
      background: #00a791;
      color: #fff;
    }
  }
}
</style>
